const globals = {
  id: 1,
  host: 'http://localhost:9009'
};

export default globals;
